export default __webpack_public_path__ + "media/images/world_map_old.jpg";